<template>
  <div v-if="license" class="mt-[50px]">
    <div
      v-for="(item, key) in licenseItems"
      :key="key"
      class="flex items-center"
      :class="{ 'mt-[10px]': key !== 'icp' }"
    >
      <label :for="key" class="w-[100px]">{{ item.label }}:</label>
      <a :href="item.url">{{ item.number }}</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { LicenseRecord } from '~/composables/license';

interface LicenseItem {
  label: string;
  number: string;
  url: string;
}

const props = defineProps<{
  license: LicenseRecord | null;
}>();

const licenseItems = computed(() => {
  const items: Record<string, LicenseItem> = {};

  if (props.license?.icp?.length) {
    items.icp = {
      label: 'ICP备案号', // @xi18n-ignore
      number: props.license.icp[0],
      url: props.license.icp[1],
    };
  }

  if (props.license?.security?.length) {
    items.security = {
      label: '公安备案号', // @xi18n-ignore
      number: props.license.security[0],
      url: props.license.security[1],
    };
  }

  if (props.license?.algorithm?.length) {
    items.algorithm = {
      label: '算法备案号', // @xi18n-ignore
      number: props.license.algorithm[0],
      url: props.license.algorithm[1],
    };
  }

  return items;
});
</script>
